import { render, staticRenderFns } from "./BoxCatalogDisplay.vue?vue&type=template&id=0c95cc7a&"
import script from "./BoxCatalogDisplay.vue?vue&type=script&lang=js&"
export * from "./BoxCatalogDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports